import type { SxProps } from '@mui/material';
import React from 'react';

import { useStartRefinFlow } from '@/hooks/useStartRefinFlow.ts';
import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import { mergeSx } from '@/lib/utils.ts';

import useBrainSession from '../../../../../../services/BrainSession/useBrainSession.ts';
import { OrangeChatButton } from '../../../_common/OrangeChatButton.tsx';

import { useHasEnded } from './useHasEnded.ts';

export type CTAProps = {
  sx?: SxProps;
};

export const CTA: React.FC<CTAProps> = ({ sx }) => {
  const { toggleChat } = useBrainSession();
  const ended = useHasEnded();
  const startRefin = useStartRefinFlow();

  if (ended) {
    return (
      <OrangeChatButton
        sx={mergeSx({ mx: 'auto' }, sx)}
        onClick={() => {
          sendUserPortalEvent('sum24_competition_cta_clicked');
          startRefin();
        }}
      >
        Søk om lavere rente
      </OrangeChatButton>
    );
  }

  return (
    <OrangeChatButton
      sx={mergeSx({ mx: 'auto' }, sx)}
      onClick={() => {
        sendUserPortalEvent('sum24_competition_cta_clicked');
        toggleChat({
          goal: 'summer_2024_campaign',
          step: 'init',
        });
      }}
    >
      Sjekk din gjeld og delta
    </OrangeChatButton>
  );
};
